// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// versions:
//   protoc-gen-ts_proto  v2.11.2
//   protoc               v5.26.1
// source: atk/enums.proto

/* eslint-disable */

export const protobufPackage = "carbon.atk";

/**
 * ATK equipment data model objects are explicitly versioned; the robot, portal
 * backend, portal frontend, and the companion app all need to touch them, and
 * they may ship at different times, so an explicit flag on each primary data
 * model object dramatically simplifies displaying/editing data which may be
 * built to an old (or new) model, offering migrations between model versions,
 * etc., rather than trying to infer the appropriate migration logic from which
 * fields are present/absent.
 */
export enum DataModelVersion {
  DATA_MODEL_VERSION_UNSPECIFIED = 0,
  DATA_MODEL_VERSION_M6_BASE = 6,
  UNRECOGNIZED = -1,
}

export function dataModelVersionFromJSON(object: any): DataModelVersion {
  switch (object) {
    case 0:
    case "DATA_MODEL_VERSION_UNSPECIFIED":
      return DataModelVersion.DATA_MODEL_VERSION_UNSPECIFIED;
    case 6:
    case "DATA_MODEL_VERSION_M6_BASE":
      return DataModelVersion.DATA_MODEL_VERSION_M6_BASE;
    case -1:
    case "UNRECOGNIZED":
    default:
      return DataModelVersion.UNRECOGNIZED;
  }
}

export function dataModelVersionToJSON(object: DataModelVersion): string {
  switch (object) {
    case DataModelVersion.DATA_MODEL_VERSION_UNSPECIFIED:
      return "DATA_MODEL_VERSION_UNSPECIFIED";
    case DataModelVersion.DATA_MODEL_VERSION_M6_BASE:
      return "DATA_MODEL_VERSION_M6_BASE";
    case DataModelVersion.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

/**
 * configuration of controlled SCV channels for autonomous jobs.  autonomous
 * jobs are divided into a set of "activities", representing different types of
 * coverage.  each task in a job is labeled with an activity; per-activity
 * behavior (speeds, path kinematics, and the actuations to perform) is
 * configured via the messages in atk/activities.proto.
 */
export enum AutonomousActivityType {
  ACTIVITY_UNSPECIFIED = 0,
  /** ACTIVITY_WORKING_ROW - the tractor is working a row (ground prepping or laser weeding it) */
  ACTIVITY_WORKING_ROW = 1,
  /** ACTIVITY_WORKING_HEADLAND - the tractor is working a headland */
  ACTIVITY_WORKING_HEADLAND = 2,
  /**
   * ACTIVITY_EORTA - renamed to ACTIVITY_TRAVERSE; note: this definition being above
   * ACTIVITY_TRAVERSE is load-bearing, because the standard JSON wire format
   * of an enum is the string name
   *
   * @deprecated
   */
  ACTIVITY_EORTA = 3,
  /** ACTIVITY_TRAVERSE - the tractor is turning around at the end of a row */
  ACTIVITY_TRAVERSE = 3,
  /** ACTIVITY_WORKING_DIVERT - the tractor should be working, but needs to divert around an obstacle */
  ACTIVITY_WORKING_DIVERT = 4,
  /**
   * ACTIVITY_COVERING_TRACKS - the tractor had to traverse through the field because it couldn't make a
   * turn at its best turning radius, and is operating with the implement
   * lowered minimally to cover its own tracks
   */
  ACTIVITY_COVERING_TRACKS = 9,
  /** ACTIVITY_TRANSPORT - the tractor is transporting between fields/locations */
  ACTIVITY_TRANSPORT = 5,
  /**
   * ACTIVITY_STARTUP - pseudo-activity entered after autonomy is authorized but before the job
   * begins (behavior TBD)
   */
  ACTIVITY_STARTUP = 6,
  /**
   * ACTIVITY_PAUSE - pseudo-activity entered when autonomy authorization is revoked or the
   * checklist expires (behavior TBD)
   */
  ACTIVITY_PAUSE = 7,
  /** ACTIVITY_SHUTDOWN - pseudo-activity entered before shutting down (behavior TBD) */
  ACTIVITY_SHUTDOWN = 8,
  UNRECOGNIZED = -1,
}

export function autonomousActivityTypeFromJSON(object: any): AutonomousActivityType {
  switch (object) {
    case 0:
    case "ACTIVITY_UNSPECIFIED":
      return AutonomousActivityType.ACTIVITY_UNSPECIFIED;
    case 1:
    case "ACTIVITY_WORKING_ROW":
      return AutonomousActivityType.ACTIVITY_WORKING_ROW;
    case 2:
    case "ACTIVITY_WORKING_HEADLAND":
      return AutonomousActivityType.ACTIVITY_WORKING_HEADLAND;
    case 3:
    case "ACTIVITY_EORTA":
      return AutonomousActivityType.ACTIVITY_EORTA;
    case 3:
    case "ACTIVITY_TRAVERSE":
      return AutonomousActivityType.ACTIVITY_TRAVERSE;
    case 4:
    case "ACTIVITY_WORKING_DIVERT":
      return AutonomousActivityType.ACTIVITY_WORKING_DIVERT;
    case 9:
    case "ACTIVITY_COVERING_TRACKS":
      return AutonomousActivityType.ACTIVITY_COVERING_TRACKS;
    case 5:
    case "ACTIVITY_TRANSPORT":
      return AutonomousActivityType.ACTIVITY_TRANSPORT;
    case 6:
    case "ACTIVITY_STARTUP":
      return AutonomousActivityType.ACTIVITY_STARTUP;
    case 7:
    case "ACTIVITY_PAUSE":
      return AutonomousActivityType.ACTIVITY_PAUSE;
    case 8:
    case "ACTIVITY_SHUTDOWN":
      return AutonomousActivityType.ACTIVITY_SHUTDOWN;
    case -1:
    case "UNRECOGNIZED":
    default:
      return AutonomousActivityType.UNRECOGNIZED;
  }
}

export function autonomousActivityTypeToJSON(object: AutonomousActivityType): string {
  switch (object) {
    case AutonomousActivityType.ACTIVITY_UNSPECIFIED:
      return "ACTIVITY_UNSPECIFIED";
    case AutonomousActivityType.ACTIVITY_WORKING_ROW:
      return "ACTIVITY_WORKING_ROW";
    case AutonomousActivityType.ACTIVITY_WORKING_HEADLAND:
      return "ACTIVITY_WORKING_HEADLAND";
    case AutonomousActivityType.ACTIVITY_EORTA:
      return "ACTIVITY_EORTA";
    case AutonomousActivityType.ACTIVITY_TRAVERSE:
      return "ACTIVITY_TRAVERSE";
    case AutonomousActivityType.ACTIVITY_WORKING_DIVERT:
      return "ACTIVITY_WORKING_DIVERT";
    case AutonomousActivityType.ACTIVITY_COVERING_TRACKS:
      return "ACTIVITY_COVERING_TRACKS";
    case AutonomousActivityType.ACTIVITY_TRANSPORT:
      return "ACTIVITY_TRANSPORT";
    case AutonomousActivityType.ACTIVITY_STARTUP:
      return "ACTIVITY_STARTUP";
    case AutonomousActivityType.ACTIVITY_PAUSE:
      return "ACTIVITY_PAUSE";
    case AutonomousActivityType.ACTIVITY_SHUTDOWN:
      return "ACTIVITY_SHUTDOWN";
    case AutonomousActivityType.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

export enum ScvAutonomyAuxControlAction {
  AUX_CONTROL_ACTION_UNSPECIFIED = 0,
  /** AUX_CONTROL_ACTION_DETENT_DOWN - when entering this activity, ATK should command detent down on the SCV */
  AUX_CONTROL_ACTION_DETENT_DOWN = 1,
  /** AUX_CONTROL_ACTION_DETENT_UP - when entering this activity, ATK should command detent up on the SCV */
  AUX_CONTROL_ACTION_DETENT_UP = 2,
  /** AUX_CONTROL_ACTION_FLOAT - when entering this activity, ATK should command float mode on the SCV */
  AUX_CONTROL_ACTION_FLOAT = 3,
  /** AUX_CONTROL_ACTION_NONE - when entering this activity, ATK should do nothing with the SCV */
  AUX_CONTROL_ACTION_NONE = 4,
  UNRECOGNIZED = -1,
}

export function scvAutonomyAuxControlActionFromJSON(object: any): ScvAutonomyAuxControlAction {
  switch (object) {
    case 0:
    case "AUX_CONTROL_ACTION_UNSPECIFIED":
      return ScvAutonomyAuxControlAction.AUX_CONTROL_ACTION_UNSPECIFIED;
    case 1:
    case "AUX_CONTROL_ACTION_DETENT_DOWN":
      return ScvAutonomyAuxControlAction.AUX_CONTROL_ACTION_DETENT_DOWN;
    case 2:
    case "AUX_CONTROL_ACTION_DETENT_UP":
      return ScvAutonomyAuxControlAction.AUX_CONTROL_ACTION_DETENT_UP;
    case 3:
    case "AUX_CONTROL_ACTION_FLOAT":
      return ScvAutonomyAuxControlAction.AUX_CONTROL_ACTION_FLOAT;
    case 4:
    case "AUX_CONTROL_ACTION_NONE":
      return ScvAutonomyAuxControlAction.AUX_CONTROL_ACTION_NONE;
    case -1:
    case "UNRECOGNIZED":
    default:
      return ScvAutonomyAuxControlAction.UNRECOGNIZED;
  }
}

export function scvAutonomyAuxControlActionToJSON(object: ScvAutonomyAuxControlAction): string {
  switch (object) {
    case ScvAutonomyAuxControlAction.AUX_CONTROL_ACTION_UNSPECIFIED:
      return "AUX_CONTROL_ACTION_UNSPECIFIED";
    case ScvAutonomyAuxControlAction.AUX_CONTROL_ACTION_DETENT_DOWN:
      return "AUX_CONTROL_ACTION_DETENT_DOWN";
    case ScvAutonomyAuxControlAction.AUX_CONTROL_ACTION_DETENT_UP:
      return "AUX_CONTROL_ACTION_DETENT_UP";
    case ScvAutonomyAuxControlAction.AUX_CONTROL_ACTION_FLOAT:
      return "AUX_CONTROL_ACTION_FLOAT";
    case ScvAutonomyAuxControlAction.AUX_CONTROL_ACTION_NONE:
      return "AUX_CONTROL_ACTION_NONE";
    case ScvAutonomyAuxControlAction.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

export enum DriveType {
  DRIVE_TYPE_UNSPECIFIED = 0,
  DRIVE_TYPE_FRONT_AXLE_STEER = 1,
  DRIVE_TYPE_DIFFERENTIAL_STEER = 2,
  UNRECOGNIZED = -1,
}

export function driveTypeFromJSON(object: any): DriveType {
  switch (object) {
    case 0:
    case "DRIVE_TYPE_UNSPECIFIED":
      return DriveType.DRIVE_TYPE_UNSPECIFIED;
    case 1:
    case "DRIVE_TYPE_FRONT_AXLE_STEER":
      return DriveType.DRIVE_TYPE_FRONT_AXLE_STEER;
    case 2:
    case "DRIVE_TYPE_DIFFERENTIAL_STEER":
      return DriveType.DRIVE_TYPE_DIFFERENTIAL_STEER;
    case -1:
    case "UNRECOGNIZED":
    default:
      return DriveType.UNRECOGNIZED;
  }
}

export function driveTypeToJSON(object: DriveType): string {
  switch (object) {
    case DriveType.DRIVE_TYPE_UNSPECIFIED:
      return "DRIVE_TYPE_UNSPECIFIED";
    case DriveType.DRIVE_TYPE_FRONT_AXLE_STEER:
      return "DRIVE_TYPE_FRONT_AXLE_STEER";
    case DriveType.DRIVE_TYPE_DIFFERENTIAL_STEER:
      return "DRIVE_TYPE_DIFFERENTIAL_STEER";
    case DriveType.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

/** Control scheme types */
export enum ControlScheme {
  CONTROL_SCHEME_UNSPECIFIED = 0,
  CONTROL_SCHEME_WHEELED = 1,
  CONTROL_SCHEME_TRACKED = 2,
  UNRECOGNIZED = -1,
}

export function controlSchemeFromJSON(object: any): ControlScheme {
  switch (object) {
    case 0:
    case "CONTROL_SCHEME_UNSPECIFIED":
      return ControlScheme.CONTROL_SCHEME_UNSPECIFIED;
    case 1:
    case "CONTROL_SCHEME_WHEELED":
      return ControlScheme.CONTROL_SCHEME_WHEELED;
    case 2:
    case "CONTROL_SCHEME_TRACKED":
      return ControlScheme.CONTROL_SCHEME_TRACKED;
    case -1:
    case "UNRECOGNIZED":
    default:
      return ControlScheme.UNRECOGNIZED;
  }
}

export function controlSchemeToJSON(object: ControlScheme): string {
  switch (object) {
    case ControlScheme.CONTROL_SCHEME_UNSPECIFIED:
      return "CONTROL_SCHEME_UNSPECIFIED";
    case ControlScheme.CONTROL_SCHEME_WHEELED:
      return "CONTROL_SCHEME_WHEELED";
    case ControlScheme.CONTROL_SCHEME_TRACKED:
      return "CONTROL_SCHEME_TRACKED";
    case ControlScheme.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

/** Hitch types */
export enum HitchType {
  HITCH_TYPE_UNSPECIFIED = 0,
  HITCH_TYPE_THREE_POINT_REAR = 1,
  HITCH_TYPE_DRAW_BAR_REAR = 2,
  HITCH_TYPE_THREE_POINT_FRONT = 3,
  UNRECOGNIZED = -1,
}

export function hitchTypeFromJSON(object: any): HitchType {
  switch (object) {
    case 0:
    case "HITCH_TYPE_UNSPECIFIED":
      return HitchType.HITCH_TYPE_UNSPECIFIED;
    case 1:
    case "HITCH_TYPE_THREE_POINT_REAR":
      return HitchType.HITCH_TYPE_THREE_POINT_REAR;
    case 2:
    case "HITCH_TYPE_DRAW_BAR_REAR":
      return HitchType.HITCH_TYPE_DRAW_BAR_REAR;
    case 3:
    case "HITCH_TYPE_THREE_POINT_FRONT":
      return HitchType.HITCH_TYPE_THREE_POINT_FRONT;
    case -1:
    case "UNRECOGNIZED":
    default:
      return HitchType.UNRECOGNIZED;
  }
}

export function hitchTypeToJSON(object: HitchType): string {
  switch (object) {
    case HitchType.HITCH_TYPE_UNSPECIFIED:
      return "HITCH_TYPE_UNSPECIFIED";
    case HitchType.HITCH_TYPE_THREE_POINT_REAR:
      return "HITCH_TYPE_THREE_POINT_REAR";
    case HitchType.HITCH_TYPE_DRAW_BAR_REAR:
      return "HITCH_TYPE_DRAW_BAR_REAR";
    case HitchType.HITCH_TYPE_THREE_POINT_FRONT:
      return "HITCH_TYPE_THREE_POINT_FRONT";
    case HitchType.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

/** PTO types */
export enum PtoType {
  PTO_TYPE_UNSPECIFIED = 0,
  PTO_TYPE_NONE = 1,
  PTO_TYPE_FRONT = 2,
  PTO_TYPE_REAR = 3,
  PTO_TYPE_FRONT_AND_REAR = 4,
  UNRECOGNIZED = -1,
}

export function ptoTypeFromJSON(object: any): PtoType {
  switch (object) {
    case 0:
    case "PTO_TYPE_UNSPECIFIED":
      return PtoType.PTO_TYPE_UNSPECIFIED;
    case 1:
    case "PTO_TYPE_NONE":
      return PtoType.PTO_TYPE_NONE;
    case 2:
    case "PTO_TYPE_FRONT":
      return PtoType.PTO_TYPE_FRONT;
    case 3:
    case "PTO_TYPE_REAR":
      return PtoType.PTO_TYPE_REAR;
    case 4:
    case "PTO_TYPE_FRONT_AND_REAR":
      return PtoType.PTO_TYPE_FRONT_AND_REAR;
    case -1:
    case "UNRECOGNIZED":
    default:
      return PtoType.UNRECOGNIZED;
  }
}

export function ptoTypeToJSON(object: PtoType): string {
  switch (object) {
    case PtoType.PTO_TYPE_UNSPECIFIED:
      return "PTO_TYPE_UNSPECIFIED";
    case PtoType.PTO_TYPE_NONE:
      return "PTO_TYPE_NONE";
    case PtoType.PTO_TYPE_FRONT:
      return "PTO_TYPE_FRONT";
    case PtoType.PTO_TYPE_REAR:
      return "PTO_TYPE_REAR";
    case PtoType.PTO_TYPE_FRONT_AND_REAR:
      return "PTO_TYPE_FRONT_AND_REAR";
    case PtoType.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

export enum PtoSpeed {
  PTO_SPEED_UNSPECIFIED = 0,
  PTO_SPEED_540 = 1,
  PTO_SPEED_540E = 2,
  PTO_SPEED_1000 = 3,
  PTO_SPEED_1000E = 4,
  UNRECOGNIZED = -1,
}

export function ptoSpeedFromJSON(object: any): PtoSpeed {
  switch (object) {
    case 0:
    case "PTO_SPEED_UNSPECIFIED":
      return PtoSpeed.PTO_SPEED_UNSPECIFIED;
    case 1:
    case "PTO_SPEED_540":
      return PtoSpeed.PTO_SPEED_540;
    case 2:
    case "PTO_SPEED_540E":
      return PtoSpeed.PTO_SPEED_540E;
    case 3:
    case "PTO_SPEED_1000":
      return PtoSpeed.PTO_SPEED_1000;
    case 4:
    case "PTO_SPEED_1000E":
      return PtoSpeed.PTO_SPEED_1000E;
    case -1:
    case "UNRECOGNIZED":
    default:
      return PtoSpeed.UNRECOGNIZED;
  }
}

export function ptoSpeedToJSON(object: PtoSpeed): string {
  switch (object) {
    case PtoSpeed.PTO_SPEED_UNSPECIFIED:
      return "PTO_SPEED_UNSPECIFIED";
    case PtoSpeed.PTO_SPEED_540:
      return "PTO_SPEED_540";
    case PtoSpeed.PTO_SPEED_540E:
      return "PTO_SPEED_540E";
    case PtoSpeed.PTO_SPEED_1000:
      return "PTO_SPEED_1000";
    case PtoSpeed.PTO_SPEED_1000E:
      return "PTO_SPEED_1000E";
    case PtoSpeed.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

export enum AtimInterface {
  ATIM_NONE = 0,
  ATIM_GENERIC = 1,
  ATIM_LASER_WEEDER = 2,
  UNRECOGNIZED = -1,
}

export function atimInterfaceFromJSON(object: any): AtimInterface {
  switch (object) {
    case 0:
    case "ATIM_NONE":
      return AtimInterface.ATIM_NONE;
    case 1:
    case "ATIM_GENERIC":
      return AtimInterface.ATIM_GENERIC;
    case 2:
    case "ATIM_LASER_WEEDER":
      return AtimInterface.ATIM_LASER_WEEDER;
    case -1:
    case "UNRECOGNIZED":
    default:
      return AtimInterface.UNRECOGNIZED;
  }
}

export function atimInterfaceToJSON(object: AtimInterface): string {
  switch (object) {
    case AtimInterface.ATIM_NONE:
      return "ATIM_NONE";
    case AtimInterface.ATIM_GENERIC:
      return "ATIM_GENERIC";
    case AtimInterface.ATIM_LASER_WEEDER:
      return "ATIM_LASER_WEEDER";
    case AtimInterface.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

export enum HydraulicCouplerType {
  HYD_COUPLER_UNSPECIFIED = 0,
  /**
   * HYD_COUPLER_ISO_5675_SIZE_12_5 - ISO 5675 standard; nominal diameter 1/2" (1.3cm).  this appears to be the
   * overwhelmingly most popular SCV coupler.
   */
  HYD_COUPLER_ISO_5675_SIZE_12_5 = 1,
  /**
   * HYD_COUPLER_ISO_5675_SIZE_20 - ISO 5675 standard; nominal diameter 3/4" (1.9cm).  this appears to be used
   * for high-flow ports on at least some tractors.
   */
  HYD_COUPLER_ISO_5675_SIZE_20 = 2,
  UNRECOGNIZED = -1,
}

export function hydraulicCouplerTypeFromJSON(object: any): HydraulicCouplerType {
  switch (object) {
    case 0:
    case "HYD_COUPLER_UNSPECIFIED":
      return HydraulicCouplerType.HYD_COUPLER_UNSPECIFIED;
    case 1:
    case "HYD_COUPLER_ISO_5675_SIZE_12_5":
      return HydraulicCouplerType.HYD_COUPLER_ISO_5675_SIZE_12_5;
    case 2:
    case "HYD_COUPLER_ISO_5675_SIZE_20":
      return HydraulicCouplerType.HYD_COUPLER_ISO_5675_SIZE_20;
    case -1:
    case "UNRECOGNIZED":
    default:
      return HydraulicCouplerType.UNRECOGNIZED;
  }
}

export function hydraulicCouplerTypeToJSON(object: HydraulicCouplerType): string {
  switch (object) {
    case HydraulicCouplerType.HYD_COUPLER_UNSPECIFIED:
      return "HYD_COUPLER_UNSPECIFIED";
    case HydraulicCouplerType.HYD_COUPLER_ISO_5675_SIZE_12_5:
      return "HYD_COUPLER_ISO_5675_SIZE_12_5";
    case HydraulicCouplerType.HYD_COUPLER_ISO_5675_SIZE_20:
      return "HYD_COUPLER_ISO_5675_SIZE_20";
    case HydraulicCouplerType.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

/**
 * as seen from above: LEFT is counterclockwise (rtc.Direction CCW), RIGHT is
 * clockwise (CW).
 */
export enum TurnDirection {
  TURN_DIRECTION_UNSPECIFIED = 0,
  TURN_DIRECTION_LEFT_ONLY = 1,
  TURN_DIRECTION_RIGHT_ONLY = 2,
  UNRECOGNIZED = -1,
}

export function turnDirectionFromJSON(object: any): TurnDirection {
  switch (object) {
    case 0:
    case "TURN_DIRECTION_UNSPECIFIED":
      return TurnDirection.TURN_DIRECTION_UNSPECIFIED;
    case 1:
    case "TURN_DIRECTION_LEFT_ONLY":
      return TurnDirection.TURN_DIRECTION_LEFT_ONLY;
    case 2:
    case "TURN_DIRECTION_RIGHT_ONLY":
      return TurnDirection.TURN_DIRECTION_RIGHT_ONLY;
    case -1:
    case "UNRECOGNIZED":
    default:
      return TurnDirection.UNRECOGNIZED;
  }
}

export function turnDirectionToJSON(object: TurnDirection): string {
  switch (object) {
    case TurnDirection.TURN_DIRECTION_UNSPECIFIED:
      return "TURN_DIRECTION_UNSPECIFIED";
    case TurnDirection.TURN_DIRECTION_LEFT_ONLY:
      return "TURN_DIRECTION_LEFT_ONLY";
    case TurnDirection.TURN_DIRECTION_RIGHT_ONLY:
      return "TURN_DIRECTION_RIGHT_ONLY";
    case TurnDirection.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}
